import { render, staticRenderFns } from "./HorasCompetencia.vue?vue&type=template&id=5276a636"
import script from "./HorasCompetencia.vue?vue&type=script&lang=js"
export * from "./HorasCompetencia.vue?vue&type=script&lang=js"
import style0 from "./HorasCompetencia.vue?vue&type=style&index=0&id=5276a636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports